var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',[_c('Col',{staticClass:"b-panel",attrs:{"span":"12"}},[_c('Tree',{attrs:{"data":_vm.treeData},on:{"on-select-change":_vm.selectData}})],1),_c('Col',{staticClass:"b-panel",attrs:{"span":"12"}},[_c('Table',{attrs:{"border":"","columns":_vm.columns1,"data":_vm.departmentList}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }